// extracted by mini-css-extract-plugin
module.exports = {"container":"search_container__2zYJJ","loading":"search_loading__3Fqig","spin":"search_spin__1xlko","input":"search_input__1SST8","iconOff":"search_iconOff__2Ocxq"};